import client from "api/client";
import type { StartApi } from "./models/start";


const base = "/script";

const start = {
	get: () => client.get<StartApi>(base)
};

export default start;